/**
 * Resource that represent a CycleCount.
 *
 * @name CycleCount
 * @class
 * @augments TmrResource
 */
function CycleCountFactory(TmrApi, TmrResource, User, ProductGroup) {
  'ngInject'
  let actions = {
    /** @method CycleCount#items */
    items: { method: 'POST', url: TmrApi.endpoint('CycleCount.items') },
    /** @method CycleCount#counters */
    counters: { method: 'GET', url: TmrApi.endpoint('CycleCount.counters') },
  }

  let referencedProperties = [
    { property: 'createdBy', resource: User },
    { property: 'productGroup', resource: ProductGroup },
  ]

  let CycleCount = TmrResource('CycleCount', actions, referencedProperties)

  return CycleCount
}

export const factory = ['CycleCount', CycleCountFactory]
